import React from "react";

const CategoryBlock = ({ text, columnHeading = "" }) => {
  // Define keyword mappings
  const config = {
    Weak: { color: "#dc3545", active: 1 },
    Niche: { color: "#ffc107", active: 2 },
    Emerging: { color: "#0dcaf0", active: 3 },
    Strong: { color: "#198754", active: 4 },
    Leader: { color: "#0d6efd", active: 5 },
    1: { color: "#dc3545", active: 1 },
    2: { color: "#ffc107", active: 2 },
    3: { color: "#0dcaf0", active: 3 },
    4: { color: "#198754", active: 4 },
    5: { color: "#0d6efd", active: 5 },
  };

   const textString = String(text || "");
  // Find which keyword is present in the text
  const foundCategory = Object.keys(config).find((key) =>
    textString.toLowerCase().includes(key.toLowerCase())
  );

  // Default fallback if no keyword is found
  const { color, active } = config[foundCategory] || {
    color: "#6c757d",
    active: 0,
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        margin: "10px 0",
      }}
    >
      {/* <span style={{ minWidth: "120px", fontWeight: "500" }}>{text}</span> */}
      <div style={{ display: "flex", gap: "6px" }}>
        {[...Array(5)].map((_, i) => (
          <div
            key={i}
            style={{
              width: "12px",
              height: "12px",
              border: `2px solid ${color}`,
              borderRadius: "24px",
              background: i < active ? color : "transparent",
              transition: "all 0.3s ease",
            }}
            // title={`${foundCategory || "Unknown"} - Level ${i + 1}`}
            title={`${columnHeading?.length > 0 ? columnHeading + ": " : ""} ${
              foundCategory || "Unknown"
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default CategoryBlock;
